module.exports = __webpack_public_path__ + "static/img/7.47927321.png";